import { useSyncExternalStore } from 'react';

import type { FlagEvaluationAttributes } from '@spotify/confidence-flag-evaluation-react';

const EMPTY_ATTRIBUTES: FlagEvaluationAttributes = Object.freeze({});

const listeners = new Set<() => void>();
let attributes: FlagEvaluationAttributes | undefined;

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const readRealEvaluationAttributes = ():
  | FlagEvaluationAttributes
  | undefined => attributes;

export const writeRealEvaluationAttributes = (
  next: FlagEvaluationAttributes,
): void => {
  attributes = next;
  listeners.forEach(listener => listener());
};

export const useRealEvaluationAttributes = (): FlagEvaluationAttributes =>
  useSyncExternalStore(
    subscribe,
    readRealEvaluationAttributes,
    () => undefined,
  ) ?? EMPTY_ATTRIBUTES;
